/**
 * 模块 - 采购管理 - 中文
 */
export default {
  purchasing: {
    creditOrderTitle: '赊货订单',
    creditOrderHelpIntro: '为了帮助经销商快速发展',
    creditOrderReqTitle: '1、下单要求',
    creditOrderReqDesc: '经销商可以向上级代理商提交赊货订单',
    creditOrderFlowTitle: '2、下单流程',
    creditOrderFlowDesc1: '需要代理商审核通过后订单生效',
    creditOrderFlowDesc2: '代理商发货后，SN流转到经销商名下',
    addPurchase: '+新增采购',
    initialPurchase: '+初始采购',
    payment: '付款',
    invoiceConfirm: '发票确认',
    changeAddress: '变更地址',
    receiptConfirm: '收货确认',
    deliveryConfirm: '发货单确认',
    cancel: '取消',
    submit: '提交',
    invoiceConfirmTitle: '确认是否已收到该订单对应金额的正规发票?',
    cancelOrderTip: '请确认是否取消订单，一旦取消，已支付款项会退回对应的代理商账户和调整对应期货订单额度！',
    orderNo: '采购单号',
    orderTime: '下单时间',
    buyNum: '采购数量',
    orderAmount: '采购金额',
    receivedAmount: '实收金额',
    received: '已收货',
    snMatch: '设备SN码与系统一致',
    bothConfirm: '*必须两者同时确认',
    changeOrderAddress: '变更订单收货地址',
    receiver: '收货人',
    receiverPhone: '收货人电话',
    provinceCity: '省市区',
    agentWarehouse: '代理商收货仓',
    address: '收货地址',
    pleaseFillReceiver: '请填写收货人',
    pleaseEnterReceiverPhone: '请输入收货人电话',
    pleaseSelectProvince: '请选择省市区',
    pleaseSelectWarehouse: '请选择代理商收货仓',
    pleaseSelectAddress: '请选择收货地址',
    pleaseEnterRemark: '请输入备注，200字以内',
    productName: '商品名称',
    discountAmount: '优惠金额',
    freightAmount: '预收运费',
    payStatus: '收款状态',
    orderStatus: '订单状态',
    productionStatus: '生产状态',
    remark: '备注',
    pleaseSelectProductionStatus: '请选择生产状态',
    receiverMobile: '收货人手机',
    dispatchNum: '发货数量',
    dispatchType: '发货方式',
    regionCampusId: '发货区代ID',
    regionCampusName: '发货区代名称',
    orderType: '订单类型',
    purchaseType: '采购类型',
    lastPayTime: '最后支付时间',
    to: '至',
    submitter: '提交人',
    submitTime: '提交时间',
    confirmTime: '确认时间',
    confirmBy: '确认人',
    creator: '创建人',
    pleaseEnterOrderNo: '请输入采购单号',
    pleaseSelectPerson: '请选择人员',
    pleaseSelectPayStatus: '请选择付款状态',
    pleaseEnterProductName: '请输入商品名称',
    pleaseSelectOrderStatus: '请选择订单状态',
    pleaseSelectOrderType: '请选择订单类型',
    pleaseSelectPurchaseTypeLabel: '请选择采购类型',
    pleaseSelectDispatchType: '请选择发货方式',
    receiverInfo: '收货人信息',
    pleaseEnterReceiverQuery: '请输入收货人姓名或手机查询',
    invoiceType: '请选择开票类型',
    invoiced: '已开票',
    notInvoiced: '未开票',
    pleaseFillValidPhone: '请填写有效的手机号',
    pleaseSelectProvinceCity: '请选择省市区 ',
    pleaseSelectAgentWarehouse: '请选择代理商收货仓库',
    pleaseFillAddress: '请填写收货地址',
    // 借调货
    secondmentGoods: '借调货',
    addRegionPurchase: '+区域采购',
    deductionPay: '抵扣支付',
    applicationNo: '申请单编号',
    applicantAgentId: '申请代理商ID',
    applicantAgentName: '申请代理商名称',
    totalAmount: '总金额',
    voucherDeductionAmount: '裂变抵扣金额',
    remainingAmount: '剩余待支付金额',
    transferNum: '调货数量',
    detail: '详情',
    confirmResult: '确认结果',
    agree: '同意',
    reject: '退回',
    confirmRemark: '确认备注',
    pleaseFillConfirmRemark: '请填写确认备注',
    confirmPaymentReceivedTip: '请确认对方收到货款后再点击同意！！！',
    confirmCancelTip: '确认取消吗',
    voucherAccount: '裂变账户',
    accountBalance: '账户余额',
    pleaseEnterContent: '请输入内容',
    maxDeductible: '最高可抵扣',
    yuan: '元',
    pleaseSelectConfirmResult: '请选择确认结果',
    paymentSuccess: '支付成功了',
    orderWithRightsCannotEdit: '此订单使用了权益，无法修改，你可以先取消订单后再重新下单。',
    orderWithVoucherCannotCancel: '该订单已返提货券，不可进行取消',
    receivedAmountMinTip: '实收金额必须>=采购金额的30%，才能提交至总部备料生产',
    paySuccess: '支付成功',
    payFail: '支付失败',
    distributeSuccess: '发放成功',
    confirmSuccess: '确认成功',
    confirmFail: '确认失败',
    cancelSuccess: '取消成功',
    cancelFail: '取消失败',
    modifySuccess: '修改成功',
    modifyFail: '修改失败',
    paymentFail: '付款失败',
    // 赊货
    creditOrders: '赊货',
    creditOrderHelpTitle: '为了帮助经销商快速发展',
    creditOrderHelpOrderReq: '下单要求',
    creditOrderHelpOrderReqDesc: '经销商可以向上级代理商提交赊货订单',
    creditOrderHelpOrderFlow: '下单流程',
    creditOrderHelpOrderFlowDesc1: '需要代理商审核通过后订单生效',
    creditOrderHelpOrderFlowDesc2: '代理商发货后，SN流转到经销商名下',
    addCreditOrder: '+新增赊货订单',
    creditOrderNo: '赊货订单编号',
    orderCreateTip: '订单创建后可以暂不付款或者部分付款，具体要求详见：',
    viewDetail: '查看详情',
    provinceAudit: '省代审核',
    auditResult: '审核结果',
    auditRemark: '审核备注',
    creditOrderConfirmTip: '请确认对方先赊货，销售设备后再付款！！！',
    exemptionPay: '是否豁免支付',
    paymentDeductionTip: '本次支付将扣除：',
    promotionFeeAccount: '推广费账户',
    voucherBonusAccount: '裂变奖金账户',
    cashAccount: '现金账户',
    goldAccount: '金账户',
    deliveryVoucherAccount: '提货券帐户',
    pleaseConfirmReceipt: '请确认是否已确认收货',
    pleaseConfirmSnMatch: '请确认设备SN与系统是否一致',
    // 双重订单
    doubleOrder: '双重订单',
    addDoubleOrder: '+新增双重订单',
    sendDeliveryVoucher: '发提货券',
    distributeVoucherTip: '一旦提前发放提货券，该双重订单将不可进行任何修改，是否确认发放提货券？',
    gotIt: '我知道了',
    paySuccessAmount: '成功支付￥{money}元',
    payFailAmount: '未能成功支付￥{money}元',
    createTime: '创建时间',
    orderNoSearch: '订单编号',
    pleaseEnterOrderNoSearch: '请输入订单编号',
    agent: '代理商',
    pleaseSelectAgent: '请选择代理商',
    regionAgent: '发货区域代理',
    pleaseSelectRegionAgent: '请选择发货区域代理',
    status: '状态',
    pleaseSelectStatus: '请选择状态',
    isVoucher: '是否裂变抵扣',
    yes: '是',
    no: '否',
    pleaseSelectExemptionPay: '请选择是否豁免支付',
    relatedAgentId: '关联代理商ID',
    relatedAgent: '关联代理商',
    relatedAgentName: '关联代理商名称',
    pleaseSelectRelatedAgent: '请选择关联代理商',
    actualPayAmount: '实付金额',
    // 采购创建/详情页
    purchaseUnit: '采购单位',
    pleaseEnterReceiver: '请输入收货人',
    phoneRequired: '手机号不能为空',
    pleaseSelectDispatch: '请选择方式',
    pleaseEnterAddress: '请输入收货地址',
    pleaseEnterWarehouse: '请输入代理商收获仓',
    selectAddGoods: '+选择添加商品',
    goodsDetail: '商品详情',
    selectDiscount: '+选择优惠',
    selectDiscountTitle: '选择优惠',
    discountInfo: '优惠信息',
    selectedVouchersAvailable: '已选{selected}张/{total}张可用',
    vouchersAvailable: '{total}张可用',
    logisticsDetail: '物流详情',
    productDetail: '商品详情',
    sequenceNo: '序号',
    orderProduct: '订单商品',
    orderPendingSendNum: '订单待发货数量',
    allocationDetailTable: '分配详情表',
    orderProductQty: '订单商品数量',
    statisticsTime: '统计时间',
    totalLabel: '合计',
    deliveryQty: '提货数量',
    creditOrderInterestTip: '您目前赊货订单有利差，请支付该订单的利差部分，共{amount}元，此赊货订单才能进入后续审核环节！',
    paymentDetail: '支付详情',
    freightDetail: '预收运费详情',
    auditDetail: '审核详情',
    priorityPurchaseRight: '享受"限量机型优先采购"权益',
    discountRightRight: '享受"进货价折扣"权益',
    originalPriceTotal: '原价合计',
    saveAndPay: '保存并支付',
    addGoods: '添加商品',
    inventoryStatusReminder: '商品库存状态提醒',
    inventoryStatusTip: '您选购的商品库存状态为',
    inventoryStatusTip2: '，到货时间可能较长，您可以返回，重新选择其他商品，或者继续下单，耐心等待发货',
    presale: '预售',
    outOfStock: '缺货',
    lowStock: '库存紧张',
    continueOrder: '继续下单',
    reselectGoods: '重新选择商品',
    customDiscountAmount: '自定义优惠金额',
    pleaseEnterCustomDiscount: '请输入自定义优惠金额',
    headquartersDeliveryTip: '样机、订阅卡、配件，请选择【总部发货】',
    changeToHeadquartersDelivery: '是否变更发货方式为：【总部发货】？',
    regionDeliveryTip: '学习机，智学笔等正价商品，请选择【区域代理发货】',
    changeToRegionDelivery: '是否变更发货方式为：【区域代理发货】？',
    limitedModelTip: '该限量机型，请选择【总部发货】',
    confirmDelete: '确认删除吗？',
    pleaseEnterCampusAddress: '请输入校区地址',
    applicantAgent: '申请代理商',
    deliveryRegionAgent: '收货区代',
    selectDeliveryRegionAgent: '发货区代',
    pleaseSelectDeliveryRegionAgent: '请选择发货区代',
    isDoubleOrder: '是否双重订单',
    pleaseEnterAgentFilter: '请输入代理商ID或名称筛选',
    payAmount: '支付金额',
    operator: '操作人',
    dispatchDate: '发货日期',
    expressCompany: '快递公司',
    expressNo: '快递单号',
    logisticsStatus: '物流状态',
    dispatchQty: '发货数量',
    chargeItem: '收费项目',
    unitPrice: '单价',
    quantity: '数量',
    amount: '金额',
    rightName: '权益名称',
    applicableProduct: '适用商品',
    expiryTime: '到期时间',
    rightCode: '权益编码',
    paySerialNo: '支付流水号',
    payMethod: '支付方式',
    payTime: '支付时间',
    auditTime: '审核时间',
    auditByName: '审核人',
    auditByCampusId: '审核人所属代理商ID',
    auditByCampusName: '审核人所属代理商名称',
    auditStatusStr: '审核结果',
    pleaseSelectDeliveryRegionAgentRule: '请选择发货区代',
    // 商品选择弹窗
    productManual: '产品说明书',
    inventory: '库存量',
    view: '查看',
    suggestedRetailPrice: '建议零售价：{price}元',
    // 采购弹框
    discount: '优惠',
    purchaseNo: '采购单号',
    purchaseUnit: '采购单位',
    creator: '创建人',
    receiver: '收货人',
    receiverAddress: '收货地址',
    receiverPhone: '收货人电话',
    remark: '备注',
    serialNo: '序号',
    unitPrice: '单价（元）',
    unitPricePlain: '单价',
    quantity: '数量（台）',
    quantityPlain: '数量',
    customDiscount: '自定义优惠金额',
    originalTotal: '原价合计',
    discountAmountLabel: '优惠金额',
    purchaseAmount: '采购金额',
    cancel: '取 消',
    save: '保存',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    performanceSplit: '业绩分单',
    orderQty: '订单数量',
    orderAmount: '订单金额',
    cashAmount: '现金金额',
    contractManager: '签约经理',
    tmkStaff: '电销人员',
    add: '+ 新增',
    splitPerson: '分单人',
    pleaseSelectPerson: '请选择人员',
    filterKeyword: '输入关键字过滤',
    splitRatio: '分单比例',
    splitAmount: '分单金额',
    delete: '删除',
    splitRatioTotal: '分单比例总计',
    splitAmountTotal: '分单金额总计',
    fillCompleteTip: '请把第{index}条数据填写完整',
    splitSuccess: '分单成功！',
    splitFail: '分单失败！',
    returnFreight: '退还运费',
    returnGoods: '退货',
    payment: '付款',
    orderTime: '下单时间',
    purchaseOrderNo: '采购单号',
    purchaseQuantity: '采购数量',
    actualPaymentAmount: '实付金额',
    shippingPlan: '发货方案',
    plan1: '方案一',
    plan2: '方案二',
    freightCollect: '运费到付',
    freightCollectTip: '收货时支付',
    prepaidFreight: '预收运费',
    freightPrepay: '运费预付',
    prepaidFreightTip: '下单时支付',
    freightCollectTipLong: '收货后支付给配送员，实际金额可能会有20%的浮动，以实际为准',
    prepaidFreightTipLong: '与订货款一起支付，出现争议由总部负责',
    purchaseFeeNoticeTitle: '本订单采购数量不足10台，按公司快递规则是: 到付;为了让大家享受邮费打折的优惠，现提供预付到付运费的服务，请注意:',
    purchaseFeeRule1: '1、到付运费折扣以公司与京东仓签订的折扣为准，目前折扣: 6.5折，以后如有变化，会及时通知;',
    purchaseFeeRule2: '2、预收到付运费自愿选择，如果放弃预付运费所享受的折扣，须在签收时支付到付运费给快递公司，具体支付金额和方式以快递公司为准;',
    purchaseFeeRule3: '3、预收到付运费收取后，如果此订单与其他订单合并配送，满足免运费条件(数量大于等于10台)，完成后，自动退还预收运费;',
    originalPrice: '原价',
    purchaseQty: '采购量',
    units: '台',
    unitPiece: '个',
    paidAmount: '实付金额',
    freightIncluded: '含运费',
    procurementAgentBalance: '采购代理商余额',
    relatedAgentAccountBalance: '关联代理账户余额',
    promoteAccount: '推广账户',
    paymentMethod: '支付方式',
    pleaseSelectPaymentMethod: '请选择以下支付方式支付',
    corporateTransfer: '对公转账',
    pay: '支付',
    voucherBonusAccount: '裂变奖金账户',
    cashAccount: '现金账户',
    accountBalance: '账户余额',
    availableAmount: '可用金额',
    otherAmount: '其他金额',
    paymentTitle: '采购支付',
    interestSpreadAmount: '利差金额',
    voucherCashNotZero: '裂变奖金账户和现金账户的金额不能同时为0，请修改！',
    paySuccess: '付款成功',
    payFail: '付款失败',
    drawInvoice: '开发票',
    invoiceType: '发票类型',
    pleaseSelectInvoiceType: '请选择发票类型',
    sendEmail: '发送邮箱',
    pleaseEnterEmail: '请输入发送邮箱',
    invalidEmailFormat: '输入邮箱格式有误!',
    deviceAmount: '设备金额',
    pleaseEnterDeviceAmount: '请输入设备金额',
    softwareAmount: '软件金额',
    pleaseEnterSoftwareAmount: '请输入软件金额',
    invalidNumberFormat: '格式错误，请输入数字！',
    amountNotNegative: '金额不能小于0',
    recalcAmount: '重算项目金额',
    total: '合计 ：',
    invoiceSuccess: '开票成功',
    invoiceFail: '开票失败',
    fillError: '填写错误',
    batchImport: '批量导入',
    uploadDoc: '上传文档',
    dataValidate: '数据校验',
    importData: '导入数据',
    complete: '完成',
    batchImportTip1: '1、模板中的表头名称及采购单信息不可更改，表头行不能删除',
    batchImportTip2: '2、一个采购单发货多台设备，复制采购单信息，每台设备一行记录',
    batchImportTip3: '3、采购单ID、采购单号判断为唯一采购单信息',
    batchImportTip4: '4、导入表格请不要超过1000行',
    selectImportFile: '选择需要导入的文件，并开始导入',
    dragOrClick: '将文件拖到此处，或',
    clickUpload: '点击上传',
    dataValidating: '数据正在校验，请稍等',
    dataValidateComplete: '数据检索完毕，共',
    orderInfo: '条订单信息',
    errorCount: '内容错误信息',
    fixAndRetry: '条，请修正后重新尝试',
    errorDetailDownload: '错误信息提示.xls',
    errorDetailDownloadTip: '详情错误信息可下载表格查看',
    importing: '数据导入中，当前页面可关闭，系统将自动完成导入。',
    importComplete: '导入完成，点击查看',
    importDetail: '导入详情',
    upload: '上传',
    confirmImport: '确定导入',
    onlyXlsFormat: '仅支持.xls格式的文件',
    noValidData: '没有一条符合上传的数据',
    warningDataError: '警告：仍有数据错误',
    partialErrorImport: '部分数据错误，若确认导入，错误数据不会导入到系统',
    submitSuccess: '提交成功',
    submitFail: '提交失败',
    pleaseSelectAgentWarehouseAddr: '请选择代理商收货仓',
    pleaseSelectDeliveryAddress: '请选择收货地址',
    deleteSuccess: '删除成功！',
    pleaseSelectGoodsFirst: '请先选择商品',
    pleaseEnterValidPhoneNum: '请输入正确手机号',
    pleaseEnterDetailAddress: '请输入详细收货地址，例如x x x省份xxx市xxx区xxx街道xxx号',
    pleaseAddGoodsQty: '请添加商品数量',
    pleaseSelectPurchaseType: '请先选择采购类型',
    provinceAgentNoCredit: '省代无法赊货，请使用线上订单向省代订货！',
    notSameEntityNoCredit: '您与上级发货代理商不是市区县代同主体，不能进行赊货！如需进货，请使用线上订单订货！',
    referralRewardStageNoCredit: '您当前还属于转介绍提现奖励阶段，请通过线上订单向介绍人下单进货！',
    onlyDealerCredit: '只有经销商可以申请赊货，您是代理商，请使用线上订单订货！',
    queryFail: '查询失败',
    saveSuccessExclamation: '保存成功!',
    saveCancelled: '已取消保存',
    // 采购单搜索/表格
    purchaseNoLabel: '采购单号：',
    pleaseEnterPurchaseNo: '请输入采购单号',
    agentLabel: '代理商：',
    orderStatusLabel: '订单状态：',
    pleaseSelectOrderStatus: '请选择订单状态',
    payStatusLabel: '收款状态：',
    pleaseSelectPayStatus: '请选择收款状态',
    orderTimeLabel: '下单日期',
    lastPayTimeLabel: '最后支付时间',
    productNameLabel: '商品名称：',
    pleaseEnterProductName: '请输入商品名称',
    purchaseQtyLabel: '采购量：',
    purchaseAmountLabel: '采购金额：',
    paidAmountLabel: '实付金额：',
    submitterLabel: '提交人：',
    pleaseSelectSubmitter: '请选择提交人',
    orderTypeLabel: '订单类型：',
    pleaseSelectOrderType: '请选择订单类型',
    submitTimeLabel: '提交时间',
    receiverInfoLabel: '收货人信息：',
    pleaseEnterReceiverQuery: '请输入收货人姓名或手机查询',
    isSplitLabel: '是否已分配过业绩：',
    pleaseSelectIsSplit: '请选择是否已分配过业绩',
    dispatchTypeLabel: '发货方式：',
    pleaseSelectDispatchType: '请选择发货方式',
    remarkLabel: '备注：',
    remarkPlaceholder: '请输入备注',
    isInvoiceLabel: '是否开票：',
    pleaseSelectInvoice: '请选择是否开票',
    productTypeLabel: '商品类型',
    pleaseSelectProductType: '请选择商品类型',
    contractAgentLabel: '签约代理商:',
    tmallOrderNoLabel: '天猫订单编号：',
    pleaseEnterTmallOrderNo: '请输入天猫订单编号',
    agentWarehouseLabel: '代理商京东仓：',
    pleaseEnterAgentWarehouse: '请输入代理商京东仓',
    isDualOrderLabel: '是否双重订单：',
    pleaseSelectIsDualOrder: '请选择是否是双重订单',
    relatedAgentLabel: '关联代理商:',
    pleaseSelectRelatedAgent: '请选择关联代理商',
    campusId: '代理商ID',
    campusName: '代理商名称',
    receiveNum: '发货数量',
    regionCampusIdLabel: '发货区代ID',
    regionCampusNameLabel: '发货区代名称',
    tmallOrderNoCol: '天猫订单编号',
    agentWarehouseNameCol: '代理商京东仓',
    dualCampusIdLabel: '关联代理商ID',
    dualCampusNameLabel: '关联代理商名称',
    submitterName: '提交人',

    // AgencyHierarchyMaintenance
    addHierarchyRelation: '+新增层级关系',
    editHierarchyRelation: '修改层级关系',
    superiorAgent: '上级代理商',
    subordinateAgent: '下级代理商',
    pleaseSelectSuperiorAgent: '请选择上级代理商',
    pleaseSelectSubordinateAgent: '请选择下级代理商',
    isSendGood: '是否发货',
    pleaseSelectIsSendGood: '请选择是否发货',
    subAgentRegion: '下级代理所属区域',
    superiorAgentId: '上级代理商ID',
    superiorAgentName: '上级代理商名称',
    agentType: '代理商类型',
    subordinateAgentId: '下级代理商ID',
    subordinateAgentName: '下级代理商名称',
    tip: '提示',
    editSuccess: '修改成功',
    editFail: '修改失败',
    deleteOrderConfirmTip: '请确认是否取消订单，一旦取消，已支付款项会退回，对应的代理商账户和调整对应期货订单额度！',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    hierarchyYes: '是',
    hierarchyNo: '否',

    // InAndOut 出入库管理
    outboundRecordImport: '出库记录导入',
    stockOutDetail: '出库明细',
    stockInRecord: '生产入库',
    snCodeUpload: 'SN码上传',
    confirmCancelStockOut: '确认取消出库?',
    stockOutWarehouse: '出库仓库',
    pleaseSelectStockOutWarehouse: '请选择出库仓库',
    stockOutType: '出库方式',
    pleaseSelectStockOutType: '请选择出库方式',
    stockOutTime: '出库时间',
    operationTime: '操作时间',
    logisticsNoLabel: '物流单号',
    pleaseEnterLogisticsNo: '请输入物流单号',
    relatedOrderNo: '关联单号',
    pleaseEnterRelatedOrderNo: '请输入关联单号',
    agentId: '代理商ID',
    agentName: '代理商名称',
    deviceSN: '设备SN码',
    logisticsCompany: '物流方式',
    operator: '操作人',
    invalid: '无效',
    valid: '有效',
    stockInNo: '入库单号',
    pleaseEnterStockInNo: '请输入入库单号',
    stockInWarehouse: '入库仓',
    pleaseSelectStockInWarehouse: '请选择入库仓',
    stockInType: '入库类型',
    pleaseSelectStockInType: '请选择入库类型',
    stockInTime: '入库时间',
    stockInStatus: '入库状态',
    pleaseSelectStockInStatus: '请选择入库状态',
    creator: '创建人',
    stockInNum: '入库数量',
    actualStockInNum: '实际入库数量',
    stockInProduct: '入库商品',
    pleaseSelectStockInProduct: '请选择入库商品',
    pleaseEnterStockInNum: '请输入入库数量',
    pleaseEnterRemark200: '请输入备注，200字以内',
    pleaseSelectDate: '请选择日期',
    uploadDoc: '上传文档',
    dataValidate: '数据校验',
    importData: '导入数据',
    complete: '完成',
    templateHeaderTip: '模板中的表头名称及采购单信息不可更改，表头行不能删除',
    selectFileToImport: '选择需要导入的文件，并开始导入',
    dataValidating: '数据正在校验，请稍等',
    dataRetrieveComplete: '数据检索完毕，共',
    orderInfoCount: '条订单信息',
    errorInfoCount: '内容错误信息',
    correctAndRetry: '条，请修正后重新尝试',
    errorDetailDownload: '详情错误信息可下载表格查看',
    errorInfoXls: '错误信息提示.xls',
    importingDataTip: '数据导入中，当前页面可关闭，系统将自动完成导入。',
    importComplete: '导入完成',
    confirmImport: '确定导入',
    dragFileTip: '将文件拖到此处，或',
    clickUpload: '点击上传',
    upload: '上传',
    confirmCancelLading: '确认取消发货单?',
    confirmCancelTransferOrder: '确认取消调库单?',
    reviewTransferOrder: '审核调拨单',
    transferOrderNo: '调拨单号',
    transferOutInfo: '调出信息',
    transferInInfo: '调入信息',
    transferOutAgent: '调出代理商',
    transferOutAgentName: '调出代理商名称',
    transferOutWarehouse: '调出仓库',
    transferInAgent: '调入代理商',
    transferInAgentName: '调入代理商名称',
    transferInWarehouse: '调入仓库',
    productInfo: '商品信息',
    transferNum: '调拨数量',
    reject: '拒绝',
    agree: '同意',
    allocationForecast: '分配预测',
    viewDetail: '查看详情',
    ladingNo: '发货单号',
    pleaseEnterLadingNo: '请输入发货单号',
    jdProductName: '京东商品名称',
    pleaseEnterJdProductName: '请输入京东商品名称',
    sendStatus: '发货状态',
    pleaseSelectSendStatus: '请选择发货状态',
    sendTime: '发货时间',
    shipWarehouse: '发货仓',
    pleaseSelectShipWarehouse: '请选择发货仓',
    relatedOrder: '关联订单',
    pleaseEnterRelatedOrder: '请输入关联订单',
    wayBillNo: '物流单号',
    pleaseEnterWayBillNo: '请输入物流单号',
    shipRegionAgentName: '发货区代名称',
    pleaseSelectShipRegionAgentName: '请选择发货区代名称',
    waitSendNum: '待发货数量',
    provinceCityDistrict: '省市区',
    receiverAddress: '收货地址',
    sendNum: '已发货数量',
    logisticsNo: '物流单号',
    tkOrderNo: '调库单号',
    pleaseEnterTkOrderNo: '请输入调库单号',
    targetWarehouse: '目的仓',
    pleaseEnterTargetWarehouse: '请输入目的仓',
    warehouseTransferStatus: '仓间调拨单状态',
    pleaseSelectWarehouseTransferStatus: '请选择状态',
    relatedTransferOrder: '关联调拨单',
    pleaseEnterRelatedTransferOrder: '请输入关联调拨单',
    cloudWarehouseTransferNo: '云仓调拨单号',
    pleaseEnterCloudWarehouseTransferNo: '请输入云仓调拨单号',
    transferInAgentId: '调入代理商ID',
    transferInAgentName: '调入代理商名称',
    transferOutAgentId: '调出代理商ID',
    transferOutAgentName: '调出代理商名称',
    tkNum: '调库数量',
    tkNumSent: '已调库数量',
    productType: '商品类型',
    pleaseSelectProductType: '请选择商品类型',
    allocationType: '分配类型',
    pleaseSelectAllocationType: '请选择分配类型',
    pendingOrderAllocation: '待发订单分配',
    orderWeightAllocation: '下单权重分配',
    allocationNum: '分配数量',
    allocationTypeCol: '分配类型',
    outOfStockNum: '缺货数量',
    availableStock: '可用库存',
    systemWeight: '系统权重%',
    systemAllocation: '系统分配',
    manualAllocation: '人工分配',
    saleShipmentExport: '销售发货导出',
    allocationListExport: '分配列表导出',
    warehouseOutDetailExport: '出库明细导出',
    warehouseInDetailExport: '入库明细导出',
    productionStockExport: '生产入库导出',
    pleaseEnterRelationNo: '请输入关联单号',
    pleaseSelectStockType: '请选择入库类型',
    pleaseSelectStockGoods: '请选择入库商品',
    pleaseSelectStockNum: '请选择入库数量',
    pleaseSelectStockWarehouse: '请选择入库仓',
    pleaseSelectStockTime: '请选择入库时间',
    createSuccess: '创建成功',
    addStockTitle: '新增入库单',
    editStockTitle: '修改入库单',
    importDataErrorTitle: '警告：仍有数据错误',
    importDataErrorContent: '部分数据错误，若确认导入，错误数据不会导入到系统',
    jdTransferOrderExport: '京东调库单导出',
    audit: '审核',
    pendingAudit: '待审核',
    rejected: '未通过',
    cancelled: '已取消',
    audited: '已审核',
    statusNew: '新建',
    statusInitial: '初始',
    statusComplete: '完成',
    statusCancelSuccess: '取消成功',
    statusGenFailed: '生成失败',
    confirmCancelStockIn: '确认取消入库?',
    vendorName: '供应商',
    pleaseEnterVendorName: '请输入供应商',
    stockInStatusInvalid: '无效',
    stockInStatusIn: '已入库',
    stockInStatusOut: '已出库',
    snCodePlaceholder: '请输入SN码',
    // 自动下单配置
    addProductRatio: '新增商品配比',
    autoOrderConfigTitle: '自动下单商品配比维护',
    agentIdLabel: '代理商ID：',
    ratioTip: '*请务必准确维护各型号配比，自动下单将根据此配比分配下单金额！所有型号配比合计必须等于100%。',
    productModel: '商品型号',
    ratioWithTotal: '配比（合计{n}%）',
    pleaseEnterRatio: '请输入配比',
    updateLog: '更新记录：',
    ratioValidationError: '请正确填写配比值：1到100的整数，且配比合计等于100%',
    autoOrderSaveSuccess: '保存成功',
    autoOrderSaveFailed: '保存失败',
    agentIdCol: '代理商id',
    agentNameCol: '代理商名称',
    productModelCol: '商品型号',
    productStatusCol: '商品状态',
    productRatioCol: '商品配比（合计=100）',
    lastUpdateTime: '末次修改时间',
    lastUpdateBy: '末次修改人',
    createByCol: '创建人',
    edit: '修改',
    detail: '详情',
    onlyXlsXlsx: '仅支持.xls和.xlsx格式的文件',
    noValidUploadData: '没有一条符合上传的数据',
    createFailed: '创建失败',
    modifyFailed: '修改失败',
    auditSuccess: '审核成功',
    rejectSuccess: '拒绝成功',
    auditFailed: '审核失败',
    rejectFailed: '拒绝失败',
    // 分配预测 Distribution
    warehouse: '仓库',
    pleaseSelectWarehouseForAllocation: '请选择仓库',
    timeLabel: '时间',
    suggestSufficientStock: '建议货源充足时使用',
    allocate: '分配',
    saveData: '保存数据',
    confirmSavePreallocation: '是否将本次预分配数据保存？',
    warehouseName: '仓库名称',
    currentPendingOrder: '当前待发货订单',
    allocationSendGoodsNum: '分配待发货订单',
    productOrderNum: '商品订单数量'
  }
}
